module.exports = __webpack_public_path__ + "static/media/landing_preview_v2.f6cba4d1.jpg";